import { range } from "lodash";
import { getWidth } from "../common";

const columns = 4;
export default range(columns).map(current => {
  const field = `sensor_photomicro_reflective_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true
  };
});
